import { ClassRequestModel, CommonResponse, CreateQuestionBankReqModel, LatestNewQuestionsResponse, LatestQuestionBankResponse, LatestQuestionBankViewReq, MigrateReqModal, QNPIdReq, QuestionBankResponse, QuestionBankViewReq, SubjectClassReqModel } from "@boi/shared-models";
import { Body, Controller, Get, Param, Post } from "@nestjs/common";
import { ApiParam, ApiTags } from "@nestjs/swagger";
import { QuestionBankService } from "./create-question.service";
import { returnException } from "@boi/backend-utils";
import { BulkCreateQuestionBankReqModel } from "@boi/shared-models";
import { QnoCountReqModelDto } from "./dtos/qnos-count.dto";

@ApiTags('CreateQuestionBank')
@Controller('createQuestionBank')
export class QuestionBankController {
    constructor(private readonly qBankService: QuestionBankService) { }

    @Post('createQuestionBank')
    async createQuestionBank(@Body() req: any[]): Promise<CommonResponse> {
        try {
            return await this.qBankService.createQuestionBank(req);
        } catch (error) {
            return returnException(CommonResponse, error);
        }
    }

    @Post('bulkCreateQuestionBank')
    async bulkCreateQuestionBank(@Body() req: BulkCreateQuestionBankReqModel): Promise<CommonResponse> {
        try {
            return await this.qBankService.bulkCreateQuestionBank(req);
        } catch (error) {
            return returnException(CommonResponse, error);
        }
    }

    @Post('updateQuestionBank')
    async updateQuestionBank(@Body() req: any): Promise<CommonResponse> {
        try {
            return await this.qBankService.updateQuestionBank(req);
        } catch (error) {
            return returnException(CommonResponse, error);
        }
    }


    @Post('getAllQuestionBankData')
    async getAllQuestionBankData(@Body() req: QuestionBankViewReq): Promise<QuestionBankResponse> {
        try {
            return await this.qBankService.getAllQuestionBankData(req);
        } catch (error) {
            return returnException(QuestionBankResponse, error);
        }
    }

    // @Post('GetSingleQuestionBankData')
    // async GetSingleQuestionBankData(@Body() req: QuestionBankViewReq): Promise<LatestQuestionBankResponse> {
    //     try {
    //         return await this.qBankService.GetSingleQuestionBankData(req);
    //     } catch (error) {
    //         return returnException(LatestQuestionBankResponse, error);
    //     }
    // }


    @Post('GetSingleQuestionBankData')
    async GetSingleQuestionBankData(@Body() req: QuestionBankViewReq): Promise<LatestNewQuestionsResponse> {
        try {
            return await this.qBankService.GetSingleQuestionBankData(req);
        } catch (error) {
            return returnException(LatestNewQuestionsResponse, error);
        }
    }

    @Post('approveQuestion')
    async approveQuestion(@Body() req: any): Promise<CommonResponse> {
        try {
            return await this.qBankService.approveQuestion(req);
        } catch (error) {
            return returnException(CommonResponse, error);
        }
    }

    @Post('getAllLatestQuestionBankData')
    async getAllLatestQuestionBankData(@Body() req: LatestQuestionBankViewReq): Promise<LatestQuestionBankResponse> {
        try {
            return await this.qBankService.getAllLatestQuestionBankData(req);
        } catch (error) {
            return returnException(LatestQuestionBankResponse, error);
        }
    }

    @Post('/activateOrDeactivateQuestion')
    async activateOrDeactivateQuestion(@Body() req: QNPIdReq): Promise<CommonResponse> {
        try {
            return await this.qBankService.activateOrDeactivateQuestion(req)
        } catch (err) {
            return returnException(CommonResponse, err);
        }
    }

    @Post('/getQuestionsCountSummery')
    async getQuestionsCountSummery(@Body() req: ClassRequestModel): Promise<CommonResponse> {
        try {
            return await this.qBankService.getQuestionsCountSummery(req);
        } catch (err) {
            return returnException(CommonResponse, err);
        }
    }

    @Post('/getQuestionSubjectPivot')
    async getQuestionSubjectPivot(@Body() req: ClassRequestModel): Promise<CommonResponse> {
        try {
            return await this.qBankService.getQuestionSubjectPivot(req);
        } catch (err) {
            return returnException(CommonResponse, err);
        }
    }

    @Post('getAllCollegeCodesAndSymbols')
    async getAllCollegeCodesAndSymbols(): Promise<CommonResponse> {
        try {
            return await this.qBankService.getAllCollegeCodesAndSymbols()
        } catch (error) {
            return returnException(CommonResponse, error)
        }
    }

    @Post('getAllQuestionsCountsBySubject')
    async getAllQuestionsCountsBySubject(@Body() req: SubjectClassReqModel): Promise<CommonResponse> {
        try {
            return await this.qBankService.getAllQuestionsCountsBySubject(req)
        } catch (error) {
            return returnException(CommonResponse, error)
        }
    }



    @Get('/getLanguagesByChapter/:chapterId')
    async getLanguagesByChapter(@Param('chapterId') chapterId: number): Promise<CommonResponse> {
        try {
            return await this.qBankService.getLanguagesByChapter(chapterId);
        } catch (error) {
            return returnException(CommonResponse, error);
        }
    }

    @Get('/getSiblingsByQno/:qno/:classId/:subjectId')
    async getSiblingsByQno(@Param('qno') qno: number, @Param('classId') classId: number, @Param('subjectId') subjectId: number): Promise<CommonResponse> {
        try {
            return await this.qBankService.getSiblingsByQno(qno, classId, subjectId);
        } catch (error) {
            return returnException(CommonResponse, error);
        }
    }

    @Post('getQuestionCountsReport')
    async getQuestionCountsReport(@Body() req: SubjectClassReqModel): Promise<CommonResponse> {
        try {
            return await this.qBankService.getQuestionCountsReport(req);
        } catch (error) {
            return returnException(CommonResponse, error);
        }
    }

    @Post('getQuestionTypeDistribution')
    async getQuestionTypeDistribution(@Body() req: SubjectClassReqModel): Promise<CommonResponse> {
        try {
            return await this.qBankService.getQuestionTypeDistribution(req);
        } catch (error) {
            return returnException(CommonResponse, error);
        }
    }

    @Post('getQuestionAbilityDistribution')
    async getQuestionAbilityDistribution(@Body() req: SubjectClassReqModel): Promise<CommonResponse> {
        try {
            return await this.qBankService.getQuestionAbilityDistribution(req);
        } catch (error) {
            return returnException(CommonResponse, error);
        }
    }

        @Post('getAvailableQuestionsByChapterAndSubAbility')
    async getTotalQuestionsCount(@Body() requestDto: QnoCountReqModelDto) {
        const totalCount = await this.qBankService.getAvailableQuestionsByChapterAndSubAbility(requestDto);
        return totalCount
    }
}